import React from 'react';

import Button from '@material-ui/core/Button';
import MicIcon from '../../../icons/MicIcon';
import MicOffIcon from '../../../icons/MicOffIcon';

import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import Tooltip from '@material-ui/core/Tooltip';
import { useAppState } from '../../../state';

export default function ToggleAudioButton(props: { disabled?: boolean; className?: string }) {
  const { user } = useAppState();
  const [isAudioEnabled, toggleAudioEnabled, disableAudio] = useLocalAudioToggle();
  const { localTracks } = useVideoContext();
  const hasAudioTrack = localTracks.some(track => track.kind === 'audio');

  React.useEffect(() => {
    if (user?.isMuted) {
      disableAudio();
    }
  }, [isAudioEnabled, user?.isMuted, disableAudio]);

  return (
    <Tooltip title="Mikrofon ki-be kapcsolása">
      <Button
        className={props.className}
        onClick={toggleAudioEnabled}
        disabled={!hasAudioTrack || props.disabled || user?.isMuted}
        data-cy-audio-toggle
      >
        {!hasAudioTrack ? /*'No Audio'*/ '' : isAudioEnabled ? /*'Mute' : 'Unmute'*/ '' : ''}
        {isAudioEnabled ? <MicIcon /> : <MicOffIcon />}
      </Button>
    </Tooltip>
  );
}
